import React from "react";
import { Download, Trash2, Image } from "lucide-react";
import { MemeSubmission } from "../../types";

interface MemesGridProps {
  memes: MemeSubmission[];
  onDeleteMeme: (id: string) => void;
  onDownloadMeme: (imageUrl: string, filename: string) => void;
  onTogglePublic: (id: string, isPublic: boolean) => void;
}

const MemesGrid: React.FC<MemesGridProps> = ({
  memes,
  onDeleteMeme,
  onDownloadMeme,
  onTogglePublic,
}) => {
  if (memes.length === 0) {
    return (
      <div className="text-center py-12">
        <Image className="h-16 w-16 text-gray-400 mx-auto mb-4" />
        <h3 className="text-xl font-semibold text-gray-700 mb-2" dir="rtl">
          עדיין אין מימז
        </h3>
        <p className="text-gray-600" dir="rtl">
          המימז הראשונים יופיעו כאן
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
      {memes.map((meme) => (
        <div
          key={meme.id}
          className="bg-white/50 rounded-lg overflow-hidden group border border-pink-200 hover:shadow-lg transition-shadow"
        >
          <div className="relative">
            <img
              src={meme.image_url}
              alt="Meme"
              className="w-full h-32 object-cover object-center"
              style={{ width: "100%", height: "128px" }}
              onError={(e) => {
                (e.target as HTMLImageElement).src =
                  "https://via.placeholder.com/300x200?text=Meme";
              }}
            />
            <div className="absolute inset-0 bg-black/70 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center space-x-2">
              <button
                onClick={() =>
                  onDownloadMeme(meme.image_url, `meme_${meme.id}.png`)
                }
                className="p-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                title="הורד"
              >
                <Download className="h-4 w-4" />
              </button>
              <button
                onClick={() => onDeleteMeme(meme.id)}
                className="p-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
                title="מחק"
              >
                <Trash2 className="h-4 w-4" />
              </button>
            </div>
          </div>
          <div className="p-3">
            {meme.creator_name && (
              <p
                className="text-xs text-gray-700 font-medium text-center mb-1"
                dir="rtl"
              >
                {meme.creator_name}
              </p>
            )}
            <p className="text-xs text-gray-600 text-center mb-2">
              {new Date(meme.created_at).toLocaleDateString("he-IL")}
            </p>
            <div className="flex items-center justify-center">
              <label
                className="flex items-center space-x-2 cursor-pointer"
                dir="rtl"
              >
                <input
                  type="checkbox"
                  checked={meme.public || false}
                  onChange={(e) => onTogglePublic(meme.id, e.target.checked)}
                  className="w-4 h-4 text-pink-600 bg-gray-100 border-gray-300 rounded focus:ring-pink-500 focus:ring-2"
                />
                <span className="text-xs text-gray-700 font-medium">
                  ציבורי
                </span>
              </label>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MemesGrid;
